export const CheckoutAuthenticatedComponent = {
    require: {
        checkout: '^checkoutStep'
    },
    template: `
        <feature-flag-wrapper flag="oo-loyalty-integration">
            <flag-on>
                <loyalty-authenticated-container></loyalty-authenticated-container>
            </flag-on>
        </feature-flag-wrapper>
        <basic-info-authenticated
            ng-if="!$ctrl.loading"
            first-name="$ctrl.data.basicInfo.firstName"
            last-name="$ctrl.data.basicInfo.lastName"
            email="$ctrl.data.basicInfo.email"
            phone-number="$ctrl.data.basicInfo.phoneNumber"
        ></basic-info-authenticated>
        <address-authenticated ng-if="$ctrl.checkoutService.isDelivery()"></address-authenticated>
        <payment-authenticated ng-if="!$ctrl.loading"></payment-authenticated>

        <oo-card>
            <oo-card-header>Promo Code</oo-card-header>
            <oo-card-body>
                <promo-code></promo-code>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(accountService, checkoutService, paymentService, $q) {
            'ngInject';
            this.accountService = accountService;
            this.checkoutService = checkoutService;
            this.paymentService = paymentService;
            this.$q = $q;
            this.data = accountService.data;
            this.loading = true;
        }

        $onInit() {
            this.$q.all([
                this.checkoutService.initialize(),
                this.accountService.getBasicInfo()
            ])
                .finally(() => this.loading = false);
        }

        $onDestroy() {
            const hasSavedPayment = this.paymentService.data.selectedPayment.guid;
            if(!hasSavedPayment) {
                this.paymentService.clearCreditCardPayment();
            }
        }
    }
};
